export enum CourseCardImageRatioEnum {
  RATIO_16_9 = '16:9',
  RATIO_21_9 = '21:9'
}
